export class SlideshowModel {

    constructor(
        public displayMode?: DisplayMode,
        public animation?: SlideshowAnimation,
        public transition?: TransitionTime
    ) { }
}

export enum SlideshowAnimation {
    NoAnimation = 'NoAnimation',
    FadeInFadeOut = 'FadeInFadeOut'
}

export enum TransitionTime {
    Slow = 'Slow',
    Normal = 'Normal',
    Fast = 'Fast'
}

export enum DisplayMode {
    Restrict = 'Restrict',
    Fill = 'Fill',
    Blur = 'Blur'
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/models/slideshow.model.ts